module.exports = __webpack_public_path__ + "img/no_search.f91b4ed4.png";